<template>
	<div class="Index">

		<router-view />

		<van-tabbar v-model="active" fixed class="van-tabbar" :z-index="99999">
			<van-tabbar-item
			v-for="(item, tabbar_index) in tabbar_items"
			:key="tabbar_index"
			:class="{'skin_color':(tabbar_index==active),'lager_tabbar':tabbar_index==2}"
			:to="item.url?item.url:''"
			:icon="tabbar_index==2?((tabbar_index==active&&showMoreLink)?'aim':'add-square'):(tabbar_index==active?item.code:(item.code+'-o'))"
			:dot="(tabbar_dot[item.code]&&tabbar[item.code]>0)?true:false"
			@click="clickTabbar(tabbar_index)"
			>
				<span>{{item.text||''}}</span>
				<!--img
				  slot="icon"
				  slot-scope="props"
				  :src="props.active ? item.icon[1] : item.icon[0]"
				/-->
			</van-tabbar-item>
		</van-tabbar>

		<div class="link-more" v-if="showMoreLink" @click="hideMoreLink">
			<div class="shop-link" @click.stop="toMoreLink('/Shop')">
				<van-icon name="shop-collect-o" size="22px"/>
				<div>街坊店</div>
			</div>
			<div class="clans-link" @click.stop="toMoreLink('/Clans')">
				<van-icon name="cluster" />
				<div>族谱</div>
			</div>
		</div>

		<!-- 单聊消息声音提醒 -->
		<audio controls="controls" hidden src="./static/mp3/msg.wav" ref="altaudio"></audio>

	</div>
</template>
<script>
export default {
	name: "Index",
	data() {
		return {
			active: 0,
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
			tabbar_items: [
				{
					text: "资讯",
					url: "/News",
					code:'fire',
					icon: [
						require("../../src/assets/img/icon/tabbar/msg-default.png"),
						require("../../src/assets/img/icon/tabbar/msg-light.png")
					],
					dot:false
				},/**
				{
					text: "街坊店",
					url: "/Shop",
					code:'shop-collect',
					icon: [
						require("../../src/assets/img/icon/tabbar/msg-default.png"),
						require("../../src/assets/img/icon/tabbar/msg-light.png")
					],
					dot:false
				},*/
				{
					text: "消息",
					url: "/Chat",
					code:'chat',
					icon: [
						require("../../src/assets/img/icon/tabbar/msg-default.png"),
						require("../../src/assets/img/icon/tabbar/msg-light.png")
					]
				},
				{
					text: "",
					code:'add-square',
					icon: [
						require("../../src/assets/img/icon/tabbar/msg-default.png"),
						require("../../src/assets/img/icon/tabbar/msg-light.png")
					],
					dot:false
				},
				/**
				{
					text: "族谱录",
					url: "/Clans",
					code:'cluster',
					icon: [
						require("../../src/assets/img/icon/tabbar/msg-default.png"),
						require("../../src/assets/img/icon/tabbar/msg-light.png")
					],
					dot:false
				},
				*/
				{
					text: "通讯录",
					url: "/Friend",
					code:'friends',
					icon: [
						require("../../src/assets/img/icon/tabbar/address-default.png"),
						require("../../src/assets/img/icon/tabbar/address-light.png")
					]
				},
				{
					text: "我的",
					url: "/My",
					code:'manager',
					icon: [
						require("../../src/assets/img/icon/tabbar/my-default.png"),
						require("../../src/assets/img/icon/tabbar/my-light.png")
					]
				}
			],
			tabbar_dot:{
				chat:0,
				manager:0
			},
			chkWebsocketTimer:false,
			showMoreLink:false,
			preTabActive:0
		};
	},
	created() {
		//var params = this.$route.query;
		//this.active = params.active||0;
		this.resetActive();
		this.chkSocketState();
	},
	watch: {
		$route: function(to, from) {
			this.currentRouter = to.path;
		}
	},
	beforeMount() {
		this.currentRouter = this.$route.path;
	},
	methods: {
		resetActive(){
			let rpaths = this.$route.path.toLowerCase().split("/");
			//console.log(rpaths)
			//rpaths = rpaths[rpaths.length-1].split("?");
			//console.log(rpaths)
			if(rpaths[1] == "shop" || rpaths[1] == "clans"){
				this.active = 2;
			}else if(rpaths[1] == "chat"){
				this.active = 1;
			}else if(rpaths[1] == "friend"){
				this.active = this.tabbar_items.length-2;
			}else if(rpaths[1] == "my"){
				this.active = this.tabbar_items.length-1;
			}

			this.preTabActive = this.active;
		},
		chkSocketState() {
			if ( this.websocket && this.websocket.ws && this.websocket.ws.readyState == 1 ) {
				// 监听消息回调
				this.websocket.ws.onmessage = this.getMessage;
				if (this.latestInterTmer) {
					clearInterval(this.latestInterTmer);
				}
			}
			this.chkWebsocketTimer && clearTimeout(this.chkWebsocketTimer)
			this.chkWebsocketTimer = setTimeout(() => {
				this.chkSocketState();
			}, 2000);
		},
		getMessage: function(msg) {
			var that = this;
			var data = JSON.parse(msg.data);
			if (data && data.m_type == "alert") {
				that.$toast(data.data.m_post_messages);
				return;
			}
			switch (data.status) {
				case 1:
					// token为空时
					that.$dialog
					.alert({
						message: data.message
					})
					.then(() => {
						that.$router.push({ path: "/Login" });
					});
					break;
				case 2:
					// 重新连接socket fd改变，客户端与服务端token相等时，不退出登入
					if (localStorage.getItem(localStorage.getItem("u_id") + "token") == data.token) {
						return;
					}
					// 用户在别处登录，客服端与服务端token不相等时
					// 客户端token 与 后台token不相等时，退出登入
					window.localStorage.clear();

					that.$dialog
					.alert({
						message: data.message
					})
					.then(() => {
						// on close
						window.localStorage.clear();
						that.$router.push({ path: "/Login" });
					});
					break;
				case 3:
					that.websocket.recordUnreadChat(data);
					//播放声音
					if(data.tag == "one"){
						var noDisturbing = localStorage.getItem( data.data.m_from_user_id + "noDisturbing" );
						if (that.u_id != data.data.m_from_user_id && noDisturbing != 1) {
							// console.log("当前chat播放音乐用户id：" + that.u_id);
							that.$refs.altaudio.currentTime = 0; //从头开始播放提示音
							that.$refs.altaudio.play(); //播放
						}
					}else if (data.tag == "group") {
						var groupNoDistrrbing = localStorage.getItem( data.ug_id + "groupNoDistrrbing" );
						if ( that.u_id != data.data[0].gm_from_id && groupNoDistrrbing != 1
						) {
							// console.log("当前chat播放音乐用户id：" + that.u_id);
							that.$refs.altaudio.currentTime = 0; //从头开始播放提示音
							that.$refs.altaudio.play(); //播放
						}
					}
					that.tabbar_dot.chat = that.websocket.staticsMsgUnread();
					break;
				case 6:
					that.websocket.recordUnreadShareLike();
					that.websocket.staticsShareUnread();
					break;
				case 7:
					that.websocket.recordUnreadShareComment(data);
					that.tabbar_dot.manager = that.websocket.staticsShareUnread();
					break;
				case 99:
					that.$toast('你有一条新的'+data.message);
					break;
				default:
					break;
			}
		},
		clickTabbar(ind){
			if(ind==2){
				this.showMoreLink = !this.showMoreLink;
			}else{
				this.preTabActive = ind;
			}
		},
		toMoreLink(uri){
			this.$router.push({path:uri});
			this.showMoreLink = false;
		},
		hideMoreLink(){
			this.showMoreLink=false;
			this.active = this.preTabActive;
		}
	},
	beforeDestroy() {
		if (this.chkWebsocketTimer) clearTimeout(this.chkWebsocketTimer)
	},
	watch: {
		$route(to, from) {
			this.showMoreLink = false;
			this.resetActive();
			if (this.websocket && this.websocket.ws && this.websocket.ws.readyState == 1 ) {
				this.websocket.ws.onmessage = this.getMessage;
			}			
		}
	},
};
</script>




// WEBPACK FOOTER //
// src/components/Index.vue